import {
  FETCH_DURATION_BEGIN,
  FETCH_DURATION_SUCCESS,
  FETCH_DURATION_FAILURE
} from '../actions/types';

const initialState = {
  duration: null,
  loading: false,
  error: null
};

export default function productReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DURATION_BEGIN:
      return {
        ...state,
        loading: true,
        duration: null,
        error: null
      };
    case FETCH_DURATION_SUCCESS:
      return {
        ...state,
        loading: false,
        duration: action.payload.duration
      };
    case FETCH_DURATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        duration: null
      };
    default:
      return state;
  }
}